import React from 'react'
import { ModalColorTheme } from 'theme/modal/colors'
import AlchemyModal, { ModalBody, ModalHeader, ModalProps } from 'UIKit/AlchemyModal'
import WarningOnTelegram from './WarningOnTelegram'

const WarningOnTelegramModal: React.FC<ModalProps> = ({ onDismiss }) => {
  return (
    <AlchemyModal
      minWidth={['100% !important', '', '440px !important']}
      maxWidth={['100% !important', '', '440px !important']}
      onDismiss={onDismiss}
      colorTheme={ModalColorTheme.Darkblue}
    >
      <ModalHeader colorTheme={ModalColorTheme.Darkblue} />

      <ModalBody>
        <WarningOnTelegram />
      </ModalBody>
    </AlchemyModal>
  )
}

export default WarningOnTelegramModal
